"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-file-line-count
// tslint:disable:object-literal-sort-keys
var React = require("react");
var EditCapacityState_1 = require("./EditCapacityState");
var styles = require("./EditCapacity.scss");
var ui_components_1 = require("@idp/ui-components");
var utils_1 = require("@idp/ui-components/utils");
var ReportingService_1 = require("../../../../api/ReportingService");
var Api_1 = require("../../../../api/Api");
var StateProvider_1 = require("../../../../api/StateProvider");
var ui_components_2 = require("@idp/ui-components");
var components_1 = require("@idp/duc/components");
var Utils = require("../../../../utils/UtilityFunctions");
var CartActions_1 = require("../../../../models/requests/CartActions");
var CartUtilFunctions_1 = require("../../../../utils/CartUtilFunctions");
var components_2 = require("@idp/duc/components");
var wlsUtils = require("../../../../utils/WirelessUtilFunctions");
var localdatastore_1 = require("../../../../config/localdatastore");
var SimpleModalProps_1 = require("@idp/duc/components/containers/SimpleModal/SimpleModalProps");
var CAPACITY_NAME = 'cpty-';
var EditCapacity = /** @class */ (function (_super) {
    __extends(EditCapacity, _super);
    function EditCapacity(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.filteredData = {};
        _this.colorOptions = new Array();
        _this.caseColorOptions = new Array();
        _this.bandColorOptions = new Array();
        _this.capacityOption = new Array();
        _this.caseFinishOptions = new Array();
        _this.bandSizeOptions = new Array();
        _this.bandTypeOptions = new Array();
        _this.availableColors = [];
        _this.availableCaseFinishes = [];
        _this.availableCaseColors = [];
        _this.availableBandSizes = [];
        _this.availableBandTypes = [];
        _this.availableBandColors = [];
        _this.currentSelelected = {
            bandColor: null,
            bandSize: null,
            bandType: null,
            caseColor: null,
            caseFinish: null,
            deviceColor: null,
            deviceInternalMemory: '',
            deviceInternalMemoryUOM: '',
            productSKU: null,
        };
        _this.productDetails = {
            commitmentTermId: '',
            contractDisplayName: '',
            contractType: '',
            installmentPlanDefinition: '',
            itemId: '',
            losgId: '',
            losgType: '',
            productCode: '',
            productType: '',
            skuID: '',
        };
        _this.isColorAvailable = false;
        _this.isCaseFinishAvailable = false;
        _this.isCaseColorAvailable = false;
        _this.isBandSizeAvailable = false;
        _this.isBandTypeAvailable = false;
        _this.isBandColorAvailable = false;
        _this.billCodes = new Array();
        _this.setDefaultFocusDone = false;
        _this.isCommonCart = false;
        _this.state = new EditCapacityState_1.default();
        _this.api = new Api_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.reportingService = new ReportingService_1.default();
        _this.setMatchedSelection = _this.setMatchedSelection.bind(_this);
        _this.changeCapacity = _this.changeCapacity.bind(_this);
        _this.showCapacityModal = _this.showCapacityModal.bind(_this);
        _this.sortCapacities = _this.sortCapacities.bind(_this);
        _this.onColorChange = _this.onColorChange.bind(_this);
        _this.onCaseColorChange = _this.onCaseColorChange.bind(_this);
        _this.onBandColorChange = _this.onBandColorChange.bind(_this);
        _this.setCurrentSelection = _this.setCurrentSelection.bind(_this);
        _this.displayCapacityOption = _this.displayCapacityOption.bind(_this);
        _this.displayCaseFinishOption = _this.displayCaseFinishOption.bind(_this);
        _this.displayBandSizeOption = _this.displayBandSizeOption.bind(_this);
        _this.displayBandTypeOption = _this.displayBandTypeOption.bind(_this);
        _this.submitSaveDevice = _this.submitSaveDevice.bind(_this);
        _this.displayColorOption = _this.displayColorOption.bind(_this);
        _this.onCapacityChange = _this.onCapacityChange.bind(_this);
        _this.buildAddToCartData = _this.buildAddToCartData.bind(_this);
        _this.mapInstallenmentPlanDefinition = _this.mapInstallenmentPlanDefinition.bind(_this);
        _this.getProductContractDetails = _this.getProductContractDetails.bind(_this);
        _this.getExtDeliveryDates = _this.getExtDeliveryDates.bind(_this);
        _this.setDeliveryDates = _this.setDeliveryDates.bind(_this);
        _this.setDefaultFocus = _this.setDefaultFocus.bind(_this);
        _this.buildAddToCartList = _this.buildAddToCartList.bind(_this);
        _this.colorCapacityChangeMsg = _this.colorCapacityChangeMsg.bind(_this);
        _this.onCapacityclose = _this.onCapacityclose.bind(_this);
        _this.saveLabel = _this.props.cmscontent &&
            (_this.props.cmscontent.saveBtnLabel ? _this.props.cmscontent.saveBtnLabel : 'Update');
        _this.isAppleWatchWearable = wlsUtils.isAppleWearableLineItem((_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.lineItemData);
        return _this;
    }
    EditCapacity.prototype.render = function () {
        var _a, _b;
        return (React.createElement("span", null,
            (Utils.isLoginRequiredonCart() || Utils.unauthenticatedAccess()) ?
                React.createElement("span", { className: styles.unathenticatedCapacity }, this.props.data.linkText) :
                React.createElement(components_2.Link, { kind: "withAppendIcon", onClick: this.changeCapacity, className: ((_a = this.props.options) === null || _a === void 0 ? void 0 : _a.showIcon) ?
                        styles.cartChangeLinkIcon : styles.cartChangeLink, testId: utils_1.default('Line', 'Capacity', this.props.data.linkText), "aria-label": "Edit Color Capacity " + this.props.data.linkText, icon: ((_b = this.props.options) === null || _b === void 0 ? void 0 : _b.showIcon) &&
                        React.createElement(components_2.IconSvg, { size: 24, svgNodeStr: Utils.GET_ICON_SVG.PEN }) }, this.props.data.linkText),
            this.state.showCapacityModal && this.showCapacityModal(),
            this.state.showCapacityModal && !this.setDefaultFocusDone && this.setDefaultFocus()));
    };
    EditCapacity.prototype.sortCapacities = function (productA, productB) {
        var MEMORY_PRIORITY = ['MB', 'GB', 'TB'];
        if (productA && productA.capacity && productA.capacity.internalMemory &&
            productB && productB.capacity && productB.capacity.internalMemory) {
            if (productA.capacity.internalMemoryUOM === productB.capacity.internalMemoryUOM) {
                return Number(productA.capacity.internalMemory) - Number(productB.capacity.internalMemory);
            }
            else {
                return MEMORY_PRIORITY.indexOf(productA.capacity.internalMemoryUOM.toUpperCase()) >
                    MEMORY_PRIORITY.indexOf(productB.capacity.internalMemoryUOM.toUpperCase()) ? 1 : -1;
            }
        }
        return 0;
    };
    EditCapacity.prototype.changeCapacity = function () {
        var _this = this;
        var _a, _b, _c;
        this.setDefaultFocusDone = false;
        this.reportingService.fireLinkClickWithOutPageLoad('Edit Color and Capacity', ReportingService_1.PageUrls.CART_EDIT_COLOR_CAPACITY_URL, 'CART');
        if (this.props && this.props.options &&
            this.props.options.lineItemData && this.props.options.lineItemData) {
            this.productDetails.skuID = this.props.options.lineItemData.productSKU;
            this.productDetails.productCode = this.props.options.lineItemData.productCode;
            this.productDetails.productType = this.props.options.lineItemData.itemType;
            if (this.props.options.lineItemData.contractDetails) {
                this.productDetails.installmentPlanDefinition =
                    this.props.options.lineItemData.contractDetails.installmentPlanDefinition || '';
                this.productDetails.contractDisplayName =
                    this.props.options.lineItemData.contractDetails.contractDisplayName || '';
                this.productDetails.contractType = this.props.options.lineItemData.contractDetails.contractType || '';
            }
        }
        if (this.props && this.props.options) {
            this.productDetails.losgId = this.props.options.losgId;
            this.productDetails.losgType = this.props.options.losgType;
            this.productDetails.itemId = this.props.options.itemId;
        }
        if (this.props.data && this.props.data.spoData && this.props.data.spoData && this.props.data.spoData.content &&
            this.props.data.spoData.content.wireless && this.props.data.spoData.content.wireless.itemList &&
            ((_a = this.props.data.spoData.content.wireless.itemList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            this.props.data.spoData.content.wireless.itemList.sort(this.sortCapacities);
            var itemList = this.props.data.spoData.content.wireless.itemList;
            var currentInternalMemory_1 = -1;
            var tempArry_1 = new Array();
            var tempColorsArry_1 = new Array();
            var tempCaseColorsArry_1 = new Array();
            var tempBandColorsArry_1 = new Array();
            this.filteredData = {};
            this.colorOptions = [];
            this.caseColorOptions = [];
            this.bandColorOptions = [];
            this.billCodes = [];
            var payload_1 = Utils.getCartResp();
            var isAppleWearable_1 = wlsUtils.isAppleWearableLineItem((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.lineItemData);
            itemList.forEach(function (value, index) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                if (value.color && tempColorsArry_1.indexOf(value.color) === -1) {
                    var colorVal = {
                        color: value.color,
                        htmlColor: value.htmlColor,
                    };
                    tempColorsArry_1.push(value.color);
                    _this.colorOptions.push(colorVal);
                }
                if (payload_1.enableEditIwatchBandInfo === true && isAppleWearable_1) {
                    var caseFinishItem = (_a = value === null || value === void 0 ? void 0 : value.skuRelations) === null || _a === void 0 ? void 0 : _a.find(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === 'caseFinish'; });
                    if ((caseFinishItem === null || caseFinishItem === void 0 ? void 0 : caseFinishItem.value) && ((_b = _this.caseFinishOptions) === null || _b === void 0 ? void 0 : _b.indexOf(caseFinishItem.value)) === -1) {
                        _this.caseFinishOptions.push(caseFinishItem.value);
                    }
                    var caseColorItem = (_c = value.skuRelations) === null || _c === void 0 ? void 0 : _c.find(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === 'caseColor'; });
                    var caseHexItem = (_d = value.skuRelations) === null || _d === void 0 ? void 0 : _d.find(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === 'caseHexValue'; });
                    if ((caseColorItem === null || caseColorItem === void 0 ? void 0 : caseColorItem.value) && (tempCaseColorsArry_1 === null || tempCaseColorsArry_1 === void 0 ? void 0 : tempCaseColorsArry_1.indexOf(caseColorItem.value)) === -1) {
                        tempCaseColorsArry_1.push(caseColorItem.value);
                        _this.caseColorOptions.push({ caseColor: caseColorItem.value, caseHexValue: caseHexItem.value });
                    }
                    var bandSizeItem = (_e = value === null || value === void 0 ? void 0 : value.skuRelations) === null || _e === void 0 ? void 0 : _e.find(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === 'bandSize'; });
                    if ((bandSizeItem === null || bandSizeItem === void 0 ? void 0 : bandSizeItem.value) && ((_f = _this.bandSizeOptions) === null || _f === void 0 ? void 0 : _f.indexOf(bandSizeItem.value)) === -1) {
                        _this.bandSizeOptions.push(bandSizeItem.value);
                    }
                    var bandTypeItem = (_g = value === null || value === void 0 ? void 0 : value.skuRelations) === null || _g === void 0 ? void 0 : _g.find(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === 'band'; });
                    if ((bandTypeItem === null || bandTypeItem === void 0 ? void 0 : bandTypeItem.value) && ((_h = _this.bandTypeOptions) === null || _h === void 0 ? void 0 : _h.indexOf(bandTypeItem.value)) === -1) {
                        _this.bandTypeOptions.push(bandTypeItem.value);
                    }
                    var bandColorItem = (_j = value.skuRelations) === null || _j === void 0 ? void 0 : _j.find(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === 'bandColor'; });
                    var bandHexItem = (_k = value.skuRelations) === null || _k === void 0 ? void 0 : _k.find(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === 'bandHexValue'; });
                    if ((bandColorItem === null || bandColorItem === void 0 ? void 0 : bandColorItem.value) && (tempBandColorsArry_1 === null || tempBandColorsArry_1 === void 0 ? void 0 : tempBandColorsArry_1.indexOf(bandColorItem.value)) === -1) {
                        tempBandColorsArry_1.push(bandColorItem.value);
                        _this.bandColorOptions.push({ bandColor: bandColorItem.value, bandHexValue: bandHexItem.value });
                    }
                }
                if (_this.props.data.productSKU && value.productSKU && _this.props.data.productSKU === value.productSKU) {
                    _this.currentSelelected.productSKU = value.productSKU || null;
                    _this.currentSelelected.deviceColor = value.color || null;
                    _this.currentSelelected.deviceInternalMemory = value.capacity && value.capacity.internalMemory;
                    _this.currentSelelected.deviceInternalMemoryUOM = value.capacity
                        && value.capacity.internalMemoryUOM || '';
                    _this.currentSelelected.htmlColor = value.htmlColor;
                }
                if (value.capacity && value.capacity.internalMemory) {
                    if (currentInternalMemory_1 === -1 ||
                        (value.capacity && value.capacity.internalMemory === currentInternalMemory_1)) {
                        currentInternalMemory_1 = value.capacity.internalMemory;
                        tempArry_1.push(value);
                    }
                    else {
                        tempArry_1 = [];
                        currentInternalMemory_1 = value.capacity.internalMemory;
                        tempArry_1.push(value);
                    }
                    var capacity = CAPACITY_NAME + value.capacity.internalMemory;
                    _this.filteredData[capacity] = tempArry_1;
                }
                if (value.billingInfo && value.billingInfo.billCode) {
                    var billCodeInfo = {
                        billCode: value.billingInfo.billCode,
                        type: _this.props.data.itemType,
                    };
                    _this.billCodes.push(billCodeInfo);
                }
            });
            this.setCurrentSelection();
            this.setState({ showCapacityModal: true });
            this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_EDIT_COLOR_CAPACITY_URL);
        }
        else {
            console.log(' No SPO Data ');
        }
    };
    EditCapacity.prototype.setCurrentSelection = function (changed) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (this.currentSelelected.deviceInternalMemory && this.currentSelelected.deviceInternalMemory !== undefined) {
            var capacity = CAPACITY_NAME + this.currentSelelected.deviceInternalMemory;
            if (this.filteredData && this.filteredData[capacity]) {
                var payload = Utils.getCartResp();
                var isAppleWearable = wlsUtils.isAppleWearableLineItem((_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.lineItemData);
                if (payload.enableEditIwatchBandInfo === true && isAppleWearable) {
                    this.availableColors = this.filteredData[capacity];
                    this.availableCaseFinishes = (_c = this.filteredData[capacity]) === null || _c === void 0 ? void 0 : _c.map(function (item) {
                        var _a, _b;
                        item.caseFinish = (_b = (_a = item.skuRelations) === null || _a === void 0 ? void 0 : _a.find(function (obj) { return (obj === null || obj === void 0 ? void 0 : obj.key) === 'caseFinish'; })) === null || _b === void 0 ? void 0 : _b.value;
                        return item;
                    });
                    this.availableCaseColors = (_d = this.filteredData[capacity]) === null || _d === void 0 ? void 0 : _d.map(function (item) {
                        var _a, _b, _c, _d;
                        item.caseColor = (_b = (_a = item.skuRelations) === null || _a === void 0 ? void 0 : _a.find(function (obj) { return (obj === null || obj === void 0 ? void 0 : obj.key) === 'caseColor'; })) === null || _b === void 0 ? void 0 : _b.value;
                        item.caseHexValue = (_d = (_c = item.skuRelations) === null || _c === void 0 ? void 0 : _c.find(function (obj) { return (obj === null || obj === void 0 ? void 0 : obj.key) === 'caseHexValue'; })) === null || _d === void 0 ? void 0 : _d.value;
                        return item;
                    });
                    this.availableBandSizes = (_e = this.filteredData[capacity]) === null || _e === void 0 ? void 0 : _e.map(function (item) {
                        var _a, _b;
                        item.bandSize = (_b = (_a = item.skuRelations) === null || _a === void 0 ? void 0 : _a.find(function (obj) { return (obj === null || obj === void 0 ? void 0 : obj.key) === 'bandSize'; })) === null || _b === void 0 ? void 0 : _b.value;
                        return item;
                    });
                    this.availableBandTypes = (_f = this.filteredData[capacity]) === null || _f === void 0 ? void 0 : _f.map(function (item) {
                        var _a, _b;
                        item.bandType = (_b = (_a = item.skuRelations) === null || _a === void 0 ? void 0 : _a.find(function (obj) { return (obj === null || obj === void 0 ? void 0 : obj.key) === 'band'; })) === null || _b === void 0 ? void 0 : _b.value;
                        return item;
                    });
                    this.availableBandColors = (_g = this.filteredData[capacity]) === null || _g === void 0 ? void 0 : _g.map(function (item) {
                        var _a, _b, _c, _d;
                        item.bandColor = (_b = (_a = item.skuRelations) === null || _a === void 0 ? void 0 : _a.find(function (obj) { return (obj === null || obj === void 0 ? void 0 : obj.key) === 'bandColor'; })) === null || _b === void 0 ? void 0 : _b.value;
                        item.bandHexValue = (_d = (_c = item.skuRelations) === null || _c === void 0 ? void 0 : _c.find(function (obj) { return (obj === null || obj === void 0 ? void 0 : obj.key) === 'bandHexValue'; })) === null || _d === void 0 ? void 0 : _d.value;
                        return item;
                    });
                    if (!changed) { // When the edit modal initially opens
                        this.isCaseFinishAvailable = false;
                        this.isCaseColorAvailable = false;
                        this.isBandSizeAvailable = false;
                        this.isBandTypeAvailable = false;
                        this.isBandColorAvailable = false;
                        for (var _i = 0, _o = this.availableColors; _i < _o.length; _i++) {
                            var item = _o[_i];
                            if (this.currentSelelected.deviceColor === item.color) {
                                this.currentSelelected.caseFinish = item === null || item === void 0 ? void 0 : item.caseFinish;
                                this.currentSelelected.caseColor = item === null || item === void 0 ? void 0 : item.caseColor;
                                this.currentSelelected.caseHexValue = item === null || item === void 0 ? void 0 : item.caseHexValue;
                                this.currentSelelected.bandSize = item === null || item === void 0 ? void 0 : item.bandSize;
                                this.currentSelelected.bandType = item === null || item === void 0 ? void 0 : item.bandType;
                                this.currentSelelected.bandColor = item === null || item === void 0 ? void 0 : item.bandColor;
                                this.currentSelelected.bandHexValue = item === null || item === void 0 ? void 0 : item.bandHexValue;
                                this.currentSelelected.productSKU = item.productSKU;
                                this.isCaseFinishAvailable = true;
                                this.isCaseColorAvailable = true;
                                this.isBandSizeAvailable = true;
                                this.isBandTypeAvailable = true;
                                this.isBandColorAvailable = true;
                            }
                        }
                    }
                    if (!this.isColorAvailable && changed && changed === 'CAP') {
                        // if false then set default
                        for (var _p = 0, _q = this.availableColors; _p < _q.length; _p++) {
                            var item = _q[_p];
                            if (item.color && item.productSKU) {
                                this.currentSelelected.deviceColor = item.color;
                                this.currentSelelected.productSKU = item.productSKU;
                                this.currentSelelected.htmlColor = item.htmlColor;
                                this.isColorAvailable = true;
                                break;
                            }
                        }
                    }
                    if (changed === 'CASE_FINISH' || changed === 'CASE_COL' || changed === 'BAND_SIZE' ||
                        changed === 'BAND_TYPE' || changed === 'BAND_COL') {
                        var defaultInternalMemory = false;
                        for (var _r = 0, _s = this.capacityOption; _r < _s.length; _r++) {
                            var capItem = _s[_r];
                            if (capItem && capItem.internalMemory) {
                                var capName = CAPACITY_NAME + capItem.internalMemory;
                                for (var _t = 0, _u = this.filteredData[capName]; _t < _u.length; _t++) {
                                    var listObj = _u[_t];
                                    if (listObj && this.isAppleWatchWearable ?
                                        (this.currentSelelected.productSKU === listObj.productSKU) :
                                        (this.currentSelelected.bandColor === listObj.bandColor &&
                                            this.currentSelelected.caseFinish === listObj.caseFinish &&
                                            this.currentSelelected.caseColor === listObj.caseColor &&
                                            this.currentSelelected.bandSize === listObj.bandSize &&
                                            this.currentSelelected.bandType === listObj.bandType)) {
                                        this.currentSelelected.deviceInternalMemory = listObj.capacity.internalMemory;
                                        this.currentSelelected.productSKU = listObj.productSKU;
                                        this.currentSelelected.caseHexValue = listObj.caseHexValue;
                                        this.currentSelelected.bandHexValue = listObj.bandHexValue;
                                        if (this.isAppleWatchWearable) {
                                            this.currentSelelected.caseFinish = listObj.caseFinish;
                                            this.currentSelelected.caseColor = listObj.caseColor;
                                            this.currentSelelected.bandType = listObj.bandType;
                                            this.currentSelelected.bandSize = listObj.bandSize;
                                            this.currentSelelected.bandColor = listObj.bandColor;
                                        }
                                        defaultInternalMemory = true;
                                        this.isCaseFinishAvailable = true;
                                        this.isCaseColorAvailable = true;
                                        this.isBandSizeAvailable = true;
                                        this.isBandTypeAvailable = true;
                                        this.isBandColorAvailable = true;
                                        this.availableColors = this.filteredData[capName];
                                        this.availableCaseFinishes = (_h = this.filteredData[capacity]) === null || _h === void 0 ? void 0 : _h.map(function (item) {
                                            var _a, _b;
                                            item.caseFinish = (_b = (_a = item.skuRelations) === null || _a === void 0 ? void 0 : _a.find(function (obj) {
                                                return (obj === null || obj === void 0 ? void 0 : obj.key) === 'caseFinish';
                                            })) === null || _b === void 0 ? void 0 : _b.value;
                                            return item;
                                        });
                                        this.availableCaseColors = (_j = this.filteredData[capacity]) === null || _j === void 0 ? void 0 : _j.map(function (item) {
                                            var _a, _b, _c, _d;
                                            item.caseColor = (_b = (_a = item.skuRelations) === null || _a === void 0 ? void 0 : _a.find(function (obj) {
                                                return (obj === null || obj === void 0 ? void 0 : obj.key) === 'caseColor';
                                            })) === null || _b === void 0 ? void 0 : _b.value;
                                            item.caseHexValue = (_d = (_c = item.skuRelations) === null || _c === void 0 ? void 0 : _c.find(function (obj) {
                                                return (obj === null || obj === void 0 ? void 0 : obj.key) === 'caseHexValue';
                                            })) === null || _d === void 0 ? void 0 : _d.value;
                                            return item;
                                        });
                                        this.availableBandSizes = (_k = this.filteredData[capacity]) === null || _k === void 0 ? void 0 : _k.map(function (item) {
                                            var _a, _b;
                                            item.bandSize = (_b = (_a = item.skuRelations) === null || _a === void 0 ? void 0 : _a.find(function (obj) {
                                                return (obj === null || obj === void 0 ? void 0 : obj.key) === 'bandSize';
                                            })) === null || _b === void 0 ? void 0 : _b.value;
                                            return item;
                                        });
                                        this.availableBandTypes = (_l = this.filteredData[capacity]) === null || _l === void 0 ? void 0 : _l.map(function (item) {
                                            var _a, _b;
                                            item.bandType = (_b = (_a = item.skuRelations) === null || _a === void 0 ? void 0 : _a.find(function (obj) {
                                                return (obj === null || obj === void 0 ? void 0 : obj.key) === 'band';
                                            })) === null || _b === void 0 ? void 0 : _b.value;
                                            return item;
                                        });
                                        this.availableBandColors = (_m = this.filteredData[capacity]) === null || _m === void 0 ? void 0 : _m.map(function (item) {
                                            var _a, _b, _c, _d;
                                            item.bandColor = (_b = (_a = item.skuRelations) === null || _a === void 0 ? void 0 : _a.find(function (obj) {
                                                return (obj === null || obj === void 0 ? void 0 : obj.key) === 'bandColor';
                                            })) === null || _b === void 0 ? void 0 : _b.value;
                                            item.bandHexValue = (_d = (_c = item.skuRelations) === null || _c === void 0 ? void 0 : _c.find(function (obj) {
                                                return (obj === null || obj === void 0 ? void 0 : obj.key) === 'bandHexValue';
                                            })) === null || _d === void 0 ? void 0 : _d.value;
                                            return item;
                                        });
                                        break;
                                    }
                                }
                            }
                            if (defaultInternalMemory) {
                                break;
                            }
                        }
                    }
                    var selectedProduct_1;
                    this.filteredData[capacity].forEach(function (product) {
                        if (product.caseFinish === _this.currentSelelected.caseFinish &&
                            product.caseColor === _this.currentSelelected.caseColor &&
                            product.bandType === _this.currentSelelected.bandType &&
                            product.bandSize === _this.currentSelelected.bandSize &&
                            product.bandColor === _this.currentSelelected.bandColor) {
                            selectedProduct_1 = product;
                        }
                    });
                    // console.log(selectedProduct);
                    this.setState({
                        isSubmitBtnDisabled: (!selectedProduct_1 || !this.isCaseFinishAvailable ||
                            !this.isCaseColorAvailable || !this.isBandSizeAvailable ||
                            !this.isBandTypeAvailable || !this.isBandColorAvailable),
                    });
                }
                else {
                    this.availableColors = this.filteredData[capacity];
                    this.isColorAvailable = false;
                    for (var _v = 0, _w = this.availableColors; _v < _w.length; _v++) {
                        var item = _w[_v];
                        if (this.currentSelelected.deviceColor === item.color) {
                            this.currentSelelected.productSKU = item.productSKU;
                            this.currentSelelected.htmlColor = item.htmlColor;
                            this.isColorAvailable = true;
                            break;
                        }
                    }
                    if (!this.isColorAvailable && changed && changed === 'CAP') {
                        // if false then set default
                        for (var _x = 0, _y = this.availableColors; _x < _y.length; _x++) {
                            var item = _y[_x];
                            if (item.color && item.productSKU) {
                                this.currentSelelected.deviceColor = item.color;
                                this.currentSelelected.productSKU = item.productSKU;
                                this.currentSelelected.htmlColor = item.htmlColor;
                                this.isColorAvailable = true;
                                break;
                            }
                        }
                    }
                    if (!this.isColorAvailable && changed && changed === 'COL') {
                        var defaultInternalMemory = false;
                        for (var _z = 0, _0 = this.capacityOption; _z < _0.length; _z++) {
                            var capItem = _0[_z];
                            if (capItem && capItem.internalMemory) {
                                var capName = CAPACITY_NAME + capItem.internalMemory;
                                for (var _1 = 0, _2 = this.filteredData[capName]; _1 < _2.length; _1++) {
                                    var listObj = _2[_1];
                                    if (listObj && listObj.color && listObj.color ===
                                        this.currentSelelected.deviceColor) {
                                        this.currentSelelected.deviceInternalMemory = listObj.capacity.internalMemory;
                                        this.currentSelelected.productSKU = listObj.productSKU;
                                        this.currentSelelected.htmlColor = listObj.htmlColor;
                                        defaultInternalMemory = true;
                                        this.isColorAvailable = true;
                                        this.availableColors = this.filteredData[capName];
                                        break;
                                    }
                                }
                            }
                            if (defaultInternalMemory) {
                                break;
                            }
                        }
                    }
                    this.setState({ isSubmitBtnDisabled: !this.isColorAvailable });
                }
            }
            this.getExtDeliveryDates();
        }
    };
    EditCapacity.prototype.showCapacityModal = function () {
        var _this = this;
        var _a, _b;
        document.querySelector('html').style.overflow = 'hidden';
        this.capacityOption = [];
        var payload = Utils.getCartResp();
        var isAppleWearable = wlsUtils.isAppleWearableLineItem((_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.lineItemData);
        Object.keys(this.filteredData).forEach(function (key) {
            var obj = _this.filteredData[key][0];
            var itemCpty = {
                internalMemory: obj.capacity.internalMemory,
                internalMemoryUOM: obj.capacity.internalMemoryUOM || '',
            };
            _this.capacityOption.push(itemCpty);
        });
        return (React.createElement(components_1.SimpleModal, { show: this.state.showCapacityModal, fade: true, sizing: SimpleModalProps_1.SimpleModalSizing.NORMAL, 
            // tslint:disable-next-line: jsx-no-lambda
            close: function () { return _this.onCapacityclose(); }, size: SimpleModalProps_1.SimpleModalSize.LARGE, accessibilityTitle: 'Edit color and capacity', labelledbyId: "ColorcapacityHeading", describedbyId: "Colorcapacitydesc" },
            React.createElement("div", { className: styles.cartccOptionsContainer },
                React.createElement(ui_components_1.Label, { testId: 'ColorcapacityHeading', data: { text: this.props.cmscontent.headingLabel }, options: { className: styles.editHeading } }),
                React.createElement("div", { id: "Colorcapacitydesc", className: styles.deviceInfo },
                    React.createElement("div", { className: styles.deviceName }, this.props.data.deviceName)),
                payload.enableEditIwatchBandInfo === true && isAppleWearable && React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.capacityContainer },
                        React.createElement("div", { className: styles.solidLine }),
                        React.createElement("div", { className: styles.capacityName },
                            React.createElement("span", null, this.props.cmscontent.caseFinishLabel)),
                        React.createElement("div", { className: styles.capacityBlock }, this.displayCaseFinishOption())),
                    React.createElement("div", { className: styles.colorContainer },
                        React.createElement("div", { className: styles.colorName },
                            React.createElement("span", null, this.props.cmscontent.caseColorLabel),
                            React.createElement("span", null,
                                " ",
                                this.currentSelelected.caseColor)),
                        React.createElement("div", { className: styles.colorSection }, this.displayCaseColorOption())),
                    React.createElement("div", { className: styles.capacityContainer },
                        React.createElement("div", { className: styles.solidLine }),
                        React.createElement("div", { className: styles.capacityName },
                            React.createElement("span", null, this.props.cmscontent.bandSizeLabel)),
                        React.createElement("div", { className: styles.capacityBlock }, this.displayBandSizeOption())),
                    React.createElement("div", { className: styles.capacityContainer },
                        React.createElement("div", { className: styles.capacityName },
                            React.createElement("span", null, this.props.cmscontent.bandTypeLabel)),
                        React.createElement("div", { className: styles.capacityBlock }, this.displayBandTypeOption())),
                    React.createElement("div", { className: styles.colorContainer },
                        React.createElement("div", { className: styles.colorName },
                            React.createElement("span", null, this.props.cmscontent.bandColorLabel),
                            React.createElement("span", null,
                                " ",
                                this.currentSelelected.bandColor)),
                        React.createElement("div", { className: styles.colorSection }, this.displayBandColorOption()))),
                !isAppleWearable && React.createElement("div", { className: styles.colorContainer },
                    React.createElement("div", { className: styles.solidLine }),
                    React.createElement("div", { className: styles.colorName },
                        React.createElement("span", null, this.props.cmscontent.colorLabel),
                        React.createElement("span", null,
                            " ",
                            this.currentSelelected.deviceColor)),
                    React.createElement("div", { className: styles.colorSection }, this.displayColorOption())),
                React.createElement("div", { className: styles.capacityContainer },
                    React.createElement("div", { className: styles.solidLine }),
                    React.createElement("div", { className: styles.capacityName },
                        React.createElement("span", null, this.props.cmscontent.capacityLabel),
                        React.createElement("span", null,
                            " ",
                            this.currentSelelected.deviceInternalMemory,
                            this.currentSelelected.deviceInternalMemoryUOM)),
                    React.createElement("div", { className: styles.capacityBlock }, this.displayCapacityOption()),
                    React.createElement("div", { className: styles.itemContainder },
                        React.createElement("span", null, "See updated price in cart after selection.")),
                    React.createElement("div", null, (this.state.isInsuranceModified &&
                        React.createElement("div", { className: styles.mb10, "data-test": "warning-msg" },
                            React.createElement(components_2.Alert, { closeable: false, onWhite: false, testId: utils_1.default('Cart', 'RTIError', 'ColorCapacityChangeAlert'), type: "warning" },
                                React.createElement("div", { className: styles.rtiErrorMsg, dangerouslySetInnerHTML: { __html: this.changeCapacityWarrningMsg } })),
                            React.createElement("div", null, this.props.cmscontent.updatedPriceWarningMsg)))),
                    React.createElement("div", { className: styles.solidLine })),
                (this.props.data.isDFShippingSelected &&
                    this.state.showEstDeliveryDate && this.deliveryDate ||
                    Utils.isEnableValidateInventory() && this.props.data &&
                        this.props.data.estimatedDeliveryDates) &&
                    (React.createElement("div", { className: styles.capacityContainer },
                        React.createElement("div", { className: styles.capacityName },
                            React.createElement(ui_components_1.Label, { data: { text: this.props.cmscontent.estDeliveryLabel }, options: { className: styles.capacityName } }),
                            React.createElement("span", { className: styles.deliverytext }, this.deliveryDate)),
                        React.createElement("div", { className: styles.solidLine }))),
                React.createElement("div", { className: styles.savebutton },
                    React.createElement(components_1.Button, { kind: "primaryBlue", testId: utils_1.default('Button', '_Save_Device'), disabled: (payload.enableEditIwatchBandInfo === true &&
                            isAppleWearable && this.state.isSubmitBtnDisabled), 
                        // tslint:disable-next-line: jsx-no-lambda
                        onClick: function () {
                            // tslint:disable-next-line: no-unused-expression
                            document.querySelector('html').style.overflowY = 'scroll';
                            _this.submitSaveDevice();
                        } }, this.props.cmscontent.saveBtnLabel)))));
    };
    EditCapacity.prototype.setMatchedSelection = function (listItems, capacity) {
        var _this = this;
        var listKeys = Object.keys(listItems);
        var matched = false;
        if ((listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) === 5) {
            this.filteredData[capacity].forEach(function (product) {
                if (listItems[listKeys[0]] === product[listKeys[0]] &&
                    listItems[listKeys[1]] === product[listKeys[1]] &&
                    listItems[listKeys[2]] === product[listKeys[2]] &&
                    listItems[listKeys[3]] === product[listKeys[3]] &&
                    listItems[listKeys[4]] === product[listKeys[4]]) {
                    matched = true;
                    if (_this.currentSelelected.productSKU) {
                        _this.currentSelelected.productSKU = product.productSKU;
                    }
                }
            });
        }
        if (!matched && listKeys.length >= 4) {
            this.filteredData[capacity].forEach(function (product) {
                if (listItems[listKeys[0]] === product[listKeys[0]] &&
                    listItems[listKeys[1]] === product[listKeys[1]] &&
                    listItems[listKeys[2]] === product[listKeys[2]] &&
                    listItems[listKeys[3]] === product[listKeys[3]]) {
                    matched = true;
                    if (_this.currentSelelected.productSKU) {
                        _this.currentSelelected.productSKU = product.productSKU;
                    }
                }
            });
        }
        if (!matched && listKeys.length >= 3) {
            this.filteredData[capacity].forEach(function (product) {
                if (listItems[listKeys[0]] === product[listKeys[0]] &&
                    listItems[listKeys[1]] === product[listKeys[1]] &&
                    listItems[listKeys[2]] === product[listKeys[2]]) {
                    matched = true;
                    if (_this.currentSelelected.productSKU) {
                        _this.currentSelelected.productSKU = product.productSKU;
                    }
                }
            });
        }
        if (!matched && listKeys.length >= 2) {
            this.filteredData[capacity].forEach(function (product) {
                if (listItems[listKeys[0]] === product[listKeys[0]] &&
                    listItems[listKeys[1]] === product[listKeys[1]]) {
                    matched = true;
                    if (_this.currentSelelected.productSKU) {
                        _this.currentSelelected.productSKU = product.productSKU;
                    }
                }
            });
        }
        if (!matched && listKeys.length >= 1) {
            this.filteredData[capacity].forEach(function (product) {
                if (listItems[listKeys[0]] === product[listKeys[0]]) {
                    matched = true;
                    if (_this.currentSelelected.productSKU) {
                        _this.currentSelelected.productSKU = product.productSKU;
                    }
                }
            });
        }
    };
    EditCapacity.prototype.onCapacityclose = function () {
        document.querySelector('html').style.overflowY = 'scroll';
        this.reportingService.fireLinkClickWithOutPageLoad('Close', ReportingService_1.PageUrls.CART_EDIT_COLOR_CAPACITY_URL);
        this.reportingService.firePageLoadEvent(CartUtilFunctions_1.getLinkClickBasekUrl());
        this.setState({ showCapacityModal: false, isInsuranceModified: false });
    };
    EditCapacity.prototype.onCapacityChange = function (selectedMemory) {
        if (selectedMemory && selectedMemory !== undefined) {
            this.currentSelelected.deviceInternalMemory = selectedMemory;
            this.setCurrentSelection('CAP');
            this.setState({ isChoiceModified: true });
            if (Utils.IsNMDPRFlow()) {
                this.colorCapacityChangeMsg();
            }
        }
    };
    EditCapacity.prototype.onCaseFinishChange = function (selectedCaseFinish) {
        if (selectedCaseFinish && selectedCaseFinish !== undefined) {
            this.currentSelelected.caseFinish = selectedCaseFinish;
            if (this.isAppleWatchWearable) {
                var listItems = {
                    caseFinish: this.currentSelelected.caseFinish,
                    caseColor: this.currentSelelected.caseColor,
                    bandType: this.currentSelelected.bandType,
                    bandSize: this.currentSelelected.bandSize,
                    bandColor: this.currentSelelected.bandColor,
                };
                var capacity = CAPACITY_NAME + this.currentSelelected.deviceInternalMemory;
                this.setMatchedSelection(listItems, capacity);
            }
            this.setCurrentSelection('CASE_FINISH');
            this.setState({ isChoiceModified: true });
            if (Utils.IsNMDPRFlow()) {
                this.colorCapacityChangeMsg();
            }
        }
    };
    EditCapacity.prototype.onCaseColorChange = function (selectedColor) {
        if (selectedColor) {
            this.currentSelelected.caseColor = selectedColor || null;
            if (this.isAppleWatchWearable) {
                var listItems = {
                    caseColor: this.currentSelelected.caseColor,
                    caseFinish: this.currentSelelected.caseFinish,
                    bandType: this.currentSelelected.bandType,
                    bandSize: this.currentSelelected.bandSize,
                    bandColor: this.currentSelelected.bandColor,
                };
                var capacity = CAPACITY_NAME + this.currentSelelected.deviceInternalMemory;
                this.setMatchedSelection(listItems, capacity);
            }
            this.setCurrentSelection('CASE_COL');
            this.setState({ isChoiceModified: true });
            if (Utils.IsNMDPRFlow()) {
                this.colorCapacityChangeMsg();
            }
        }
    };
    EditCapacity.prototype.onBandSizeChange = function (selectedBandSize) {
        if (selectedBandSize && selectedBandSize !== undefined) {
            this.currentSelelected.bandSize = selectedBandSize;
            if (this.isAppleWatchWearable) {
                var listItems = {
                    bandSize: this.currentSelelected.bandSize,
                    caseFinish: this.currentSelelected.caseFinish,
                    caseColor: this.currentSelelected.caseColor,
                    bandType: this.currentSelelected.bandType,
                    bandColor: this.currentSelelected.bandColor,
                };
                var capacity = CAPACITY_NAME + this.currentSelelected.deviceInternalMemory;
                this.setMatchedSelection(listItems, capacity);
            }
            this.setCurrentSelection('BAND_SIZE');
            this.setState({ isChoiceModified: true });
            if (Utils.IsNMDPRFlow()) {
                this.colorCapacityChangeMsg();
            }
        }
    };
    EditCapacity.prototype.onBandTypeChange = function (selectedBandType) {
        if (selectedBandType && selectedBandType !== undefined) {
            this.currentSelelected.bandType = selectedBandType;
            if (this.isAppleWatchWearable) {
                var listItems = {
                    bandType: this.currentSelelected.bandType,
                    caseFinish: this.currentSelelected.caseFinish,
                    caseColor: this.currentSelelected.caseColor,
                    bandSize: this.currentSelelected.bandSize,
                    bandColor: this.currentSelelected.bandColor,
                };
                var capacity = CAPACITY_NAME + this.currentSelelected.deviceInternalMemory;
                this.setMatchedSelection(listItems, capacity);
            }
            this.setCurrentSelection('BAND_TYPE');
            this.setState({ isChoiceModified: true });
            if (Utils.IsNMDPRFlow()) {
                this.colorCapacityChangeMsg();
            }
        }
    };
    EditCapacity.prototype.onBandColorChange = function (selectedColor) {
        if (selectedColor) {
            this.currentSelelected.bandColor = selectedColor || null;
            if (this.isAppleWatchWearable) {
                var listItems = {
                    bandColor: this.currentSelelected.bandColor,
                    caseFinish: this.currentSelelected.caseFinish,
                    caseColor: this.currentSelelected.caseColor,
                    bandSize: this.currentSelelected.bandSize,
                    bandType: this.currentSelelected.bandType,
                };
                var capacity = CAPACITY_NAME + this.currentSelelected.deviceInternalMemory;
                this.setMatchedSelection(listItems, capacity);
            }
            this.setCurrentSelection('BAND_COL');
            this.setState({ isChoiceModified: true });
            if (Utils.IsNMDPRFlow()) {
                this.colorCapacityChangeMsg();
            }
        }
    };
    EditCapacity.prototype.onColorChange = function (slectedColor) {
        if (slectedColor) {
            this.currentSelelected.deviceColor = slectedColor || null;
            this.setCurrentSelection('COL');
            this.setState({ isChoiceModified: true });
            if (Utils.IsNMDPRFlow()) {
                this.colorCapacityChangeMsg();
            }
        }
    };
    EditCapacity.prototype.colorCapacityChangeMsg = function () {
        var _this = this;
        var payload = Utils.getCartResp();
        var cartInsuranceProdCode;
        var cartInsuranceType;
        var cartInsurancePrice;
        var prodCodeMatched;
        if (payload.wirelessCart.losgs) {
            Object.keys(payload.wirelessCart.losgs).forEach(function (items) {
                var losgValues = [payload.wirelessCart.losgs[items]];
                losgValues.sort(wlsUtils.sortLogs);
                var filteredLosgsData = losgValues.filter(wlsUtils.filterLosgs);
                if (_this.productDetails.losgId === payload.wirelessCart.losgs[items].id) {
                    filteredLosgsData.forEach(function (data) {
                        var losgItems = wlsUtils.organizeLineItems(Object.values(data.lineItems), true, data);
                        losgItems.forEach(function (item) {
                            var _a, _b, _c;
                            if (item.itemType === 'feature' && item.productCode) {
                                cartInsuranceProdCode = item.productCode;
                                cartInsuranceType = item._insuranceType;
                                cartInsurancePrice = item.price.baseAmount;
                                if (_this.props.data.spoData
                                    && _this.props.data.spoData.content.wireless.itemList
                                    && _this.props.data.spoData.content.wireless.features) {
                                    _this.props.data.spoData.content.wireless.itemList.forEach(function (spoItem) {
                                        if (_this.currentSelelected.deviceColor === spoItem.color
                                            && _this.currentSelelected.deviceInternalMemory
                                                === spoItem.capacity.internalMemory && spoItem.applicableFeatures) {
                                            spoItem.applicableFeatures.forEach(function (prodId) {
                                                if (prodId === cartInsuranceProdCode) {
                                                    prodCodeMatched = true;
                                                    _this.setState({ isInsuranceModified: false });
                                                }
                                            });
                                        }
                                    });
                                    if (!prodCodeMatched) {
                                        var features = (_c = (_b = (_a = _this.props.data.spoData) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.wireless) === null || _c === void 0 ? void 0 : _c.features;
                                        Object.values(features).forEach(function (feature) {
                                            var _a, _b;
                                            if ((feature.product.childSkus[0].insuranceType
                                                === cartInsuranceType) && (feature.offerId !== cartInsuranceProdCode)) {
                                                if (feature.product.price.mrc === Number(cartInsurancePrice)) {
                                                    _this.setState({ isInsuranceModified: false });
                                                }
                                                else {
                                                    _this.setState({ isInsuranceModified: true });
                                                    _this.currentIsuranceDisplayName = feature.product.displayName;
                                                    _this.currentIsurancePrice = feature.product.price.mrc;
                                                    _this.changeCapacityWarrningMsg
                                                        = (_a = _this.props.cmscontent) === null || _a === void 0 ? void 0 : _a.changeCapacityWarrningMsg;
                                                    _this.changeCapacityWarrningMsg = _this.changeCapacityWarrningMsg.replace('{0}', (_b = _this.currentIsuranceDisplayName) === null || _b === void 0 ? void 0 : _b.toString())
                                                        .replace('{1}', _this.currentIsurancePrice.toFixed(2));
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        });
                    });
                }
            });
        }
    };
    EditCapacity.prototype.displayCapacityOption = function () {
        var _this = this;
        var _a, _b;
        var payload = Utils.getCartResp();
        var isAppleWearable = wlsUtils.isAppleWearableLineItem((_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.lineItemData);
        return (this.capacityOption.map(function (value) {
            var capacity = CAPACITY_NAME + value.internalMemory;
            var itemList = _this.filteredData[capacity];
            var btnClass;
            var isDeviceSelectionNotAvailable = true;
            if (payload.enableEditIwatchBandInfo === true && isAppleWearable) {
                isDeviceSelectionNotAvailable = !_this.isCaseFinishAvailable || !_this.isCaseColorAvailable ||
                    !_this.isBandSizeAvailable || !_this.isBandTypeAvailable || !_this.isBandColorAvailable;
            }
            else {
                isDeviceSelectionNotAvailable = !_this.isColorAvailable;
            }
            if (isDeviceSelectionNotAvailable) {
                btnClass = styles.capacityButton;
            }
            else {
                btnClass = [styles.capacityButton,
                    _this.isAppleWatchWearable ? (_this.currentSelelected.deviceInternalMemory ? '' :
                        styles.capacityDisabled) : styles.capacityDisabled].join(' ');
                for (var _i = 0, itemList_1 = itemList; _i < itemList_1.length; _i++) {
                    var item = itemList_1[_i];
                    if (item.color.toUpperCase() === _this.currentSelelected.deviceColor.toUpperCase()) {
                        btnClass = _this.currentSelelected.deviceInternalMemory === value.internalMemory ?
                            [styles.capacityButton, styles.capacityActive].join(' ') : styles.capacityButton;
                        break;
                    }
                }
            }
            return (React.createElement("div", { key: "capacity_" + value.internalMemory, className: styles.capacityBtnContainer, tabIndex: 0 },
                React.createElement("div", { className: btnClass, onClick: _this.onCapacityChange.bind(_this, value.internalMemory), "data-id": utils_1.default('change', 'capacity', value.internalMemory) },
                    value.internalMemory,
                    value.internalMemoryUOM)));
        }));
    };
    EditCapacity.prototype.displayCaseFinishOption = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var availableCaseFinishesFiltered = [];
        var capacity = CAPACITY_NAME + this.currentSelelected.deviceInternalMemory;
        var itemList = this.filteredData[capacity];
        if (itemList) {
            for (var _i = 0, itemList_2 = itemList; _i < itemList_2.length; _i++) {
                var item = itemList_2[_i];
                if (((_a = item.caseColor) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === ((_b = this.currentSelelected.caseColor) === null || _b === void 0 ? void 0 : _b.toUpperCase()) &&
                    ((_c = item.bandSize) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === ((_d = this.currentSelelected.bandSize) === null || _d === void 0 ? void 0 : _d.toUpperCase()) &&
                    ((_e = item.bandType) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === ((_f = this.currentSelelected.bandType) === null || _f === void 0 ? void 0 : _f.toUpperCase()) &&
                    ((_g = item.bandColor) === null || _g === void 0 ? void 0 : _g.toUpperCase()) === ((_h = this.currentSelelected.bandColor) === null || _h === void 0 ? void 0 : _h.toUpperCase())) {
                    availableCaseFinishesFiltered.push(item);
                }
            }
        }
        return (this.caseFinishOptions.map(function (value) {
            var btnClass;
            if (!_this.isCaseFinishAvailable) {
                btnClass = styles.capacityButton;
            }
            else {
                btnClass = [styles.capacityButton, _this.isAppleWatchWearable ? (_this.currentSelelected.caseFinish ? '' : styles.capacityDisabled) :
                        styles.capacityDisabled].join(' ');
                for (var _i = 0, availableCaseFinishesFiltered_1 = availableCaseFinishesFiltered; _i < availableCaseFinishesFiltered_1.length; _i++) {
                    var item = availableCaseFinishesFiltered_1[_i];
                    if (item.caseFinish === value) {
                        btnClass = (_this.currentSelelected.caseFinish === value) ?
                            [styles.capacityButton, styles.capacityActive].join(' ') : styles.capacityButton;
                        break;
                    }
                }
            }
            return (React.createElement("div", { key: "caseFinish_" + value, className: styles.capacityBtnContainer, tabIndex: 0 },
                React.createElement("div", { className: btnClass, onClick: _this.onCaseFinishChange.bind(_this, value), "data-id": utils_1.default('change', 'caseFinish_', value) }, value)));
        }));
    };
    EditCapacity.prototype.displayBandSizeOption = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var availableBandSizesFiltered = [];
        var capacity = CAPACITY_NAME + this.currentSelelected.deviceInternalMemory;
        var itemList = this.filteredData[capacity];
        if (itemList) {
            for (var _i = 0, itemList_3 = itemList; _i < itemList_3.length; _i++) {
                var item = itemList_3[_i];
                if (((_a = item.caseFinish) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === ((_b = this.currentSelelected.caseFinish) === null || _b === void 0 ? void 0 : _b.toUpperCase()) &&
                    ((_c = item.caseColor) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === ((_d = this.currentSelelected.caseColor) === null || _d === void 0 ? void 0 : _d.toUpperCase()) &&
                    ((_e = item.bandType) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === ((_f = this.currentSelelected.bandType) === null || _f === void 0 ? void 0 : _f.toUpperCase()) &&
                    ((_g = item.bandColor) === null || _g === void 0 ? void 0 : _g.toUpperCase()) === ((_h = this.currentSelelected.bandColor) === null || _h === void 0 ? void 0 : _h.toUpperCase())) {
                    availableBandSizesFiltered.push(item);
                }
            }
        }
        return (this.bandSizeOptions.map(function (value) {
            var btnClass;
            if (!_this.isBandSizeAvailable) {
                btnClass = styles.capacityButton;
            }
            else {
                btnClass = [styles.capacityButton,
                    _this.isAppleWatchWearable ? (_this.currentSelelected.bandSize ? '' :
                        styles.capacityDisabled) : styles.capacityDisabled].join(' ');
                for (var _i = 0, availableBandSizesFiltered_1 = availableBandSizesFiltered; _i < availableBandSizesFiltered_1.length; _i++) {
                    var item = availableBandSizesFiltered_1[_i];
                    if (item.bandSize === value) {
                        btnClass = (_this.currentSelelected.bandSize === value) ?
                            [styles.capacityButton, styles.capacityActive].join(' ') : styles.capacityButton;
                        break;
                    }
                }
            }
            return (React.createElement("div", { key: "bandSize_" + value, className: styles.capacityBtnContainer, tabIndex: 0 },
                React.createElement("div", { className: btnClass, onClick: _this.onBandSizeChange.bind(_this, value), "data-id": utils_1.default('change', 'bandSize_', value) }, value)));
        }));
    };
    EditCapacity.prototype.displayBandTypeOption = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var availableBandTypesFiltered = [];
        var capacity = CAPACITY_NAME + this.currentSelelected.deviceInternalMemory;
        var itemList = this.filteredData[capacity];
        if (itemList) {
            for (var _i = 0, itemList_4 = itemList; _i < itemList_4.length; _i++) {
                var item = itemList_4[_i];
                if (((_a = item.caseFinish) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === ((_b = this.currentSelelected.caseFinish) === null || _b === void 0 ? void 0 : _b.toUpperCase()) &&
                    ((_c = item.caseColor) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === ((_d = this.currentSelelected.caseColor) === null || _d === void 0 ? void 0 : _d.toUpperCase()) &&
                    ((_e = item.bandSize) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === ((_f = this.currentSelelected.bandSize) === null || _f === void 0 ? void 0 : _f.toUpperCase()) &&
                    ((_g = item.bandColor) === null || _g === void 0 ? void 0 : _g.toUpperCase()) === ((_h = this.currentSelelected.bandColor) === null || _h === void 0 ? void 0 : _h.toUpperCase())) {
                    availableBandTypesFiltered.push(item);
                }
            }
        }
        return (this.bandTypeOptions.map(function (value) {
            var btnClass;
            if (!_this.isBandTypeAvailable) {
                btnClass = styles.capacityButton;
            }
            else {
                btnClass = [styles.capacityButton,
                    _this.isAppleWatchWearable ? (_this.currentSelelected.bandType ? '' : styles.capacityDisabled) :
                        styles.capacityDisabled].join(' ');
                for (var _i = 0, availableBandTypesFiltered_1 = availableBandTypesFiltered; _i < availableBandTypesFiltered_1.length; _i++) {
                    var item = availableBandTypesFiltered_1[_i];
                    if (item.bandType === value) {
                        btnClass = (_this.currentSelelected.bandType === value) ?
                            [styles.capacityButton, styles.capacityActive].join(' ') : styles.capacityButton;
                        break;
                    }
                }
            }
            return (React.createElement("div", { key: "bandType_" + value, className: styles.capacityBtnContainer, tabIndex: 0 },
                React.createElement("div", { className: btnClass, onClick: _this.onBandTypeChange.bind(_this, value), "data-id": utils_1.default('change', 'bandType_', value) }, value)));
        }));
    };
    EditCapacity.prototype.displayCaseColorOption = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var groupData = {
            defaultChecked: this.currentSelelected.caseColor,
            name: 'wlsCaseColorGroup',
            selected: this.currentSelelected.caseColor,
        };
        var availableCaseColorsFiltered = [];
        for (var _i = 0, _j = this.availableBandColors; _i < _j.length; _i++) {
            var item = _j[_i];
            if (((_a = item.caseFinish) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === ((_b = this.currentSelelected.caseFinish) === null || _b === void 0 ? void 0 : _b.toUpperCase()) &&
                ((_c = item.bandSize) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === ((_d = this.currentSelelected.bandSize) === null || _d === void 0 ? void 0 : _d.toUpperCase()) &&
                ((_e = item.bandType) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === ((_f = this.currentSelelected.bandType) === null || _f === void 0 ? void 0 : _f.toUpperCase()) &&
                ((_g = item.bandColor) === null || _g === void 0 ? void 0 : _g.toUpperCase()) === ((_h = this.currentSelelected.bandColor) === null || _h === void 0 ? void 0 : _h.toUpperCase())) {
                availableCaseColorsFiltered.push(item);
            }
        }
        return (React.createElement(ui_components_2.RadioGroup, { data: groupData, events: { onChange: this.onCaseColorChange }, options: { elementsDirection: 'row' }, testId: 'WLS_Case_Color_Radio_Group' }, this.caseColorOptions && this.caseColorOptions.map(function (options, index) {
            var isCaseColorAvailable = false;
            availableCaseColorsFiltered.forEach(function (item) {
                if (options.caseColor === item.caseColor) {
                    isCaseColorAvailable = true;
                }
            });
            var colorData = {
                color: options.caseHexValue,
                disabled: false,
                options: options.caseColor,
                strike: !isCaseColorAvailable,
                value: options.caseColor,
            };
            return (React.createElement(ui_components_2.RadioColor, { key: "color_" + options.caseColor, data: colorData, options: {
                    accessibility: options.caseColor,
                    arialabelledby: 'radioColor_' + index,
                    className: styles.colorsize,
                    tabIndex: 0
                } }));
        })));
    };
    EditCapacity.prototype.displayBandColorOption = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var groupData = {
            defaultChecked: this.currentSelelected.bandColor,
            name: 'wlsBandColorGroup',
            selected: this.currentSelelected.bandColor,
        };
        var availableBandColorsFiltered = [];
        for (var _i = 0, _j = this.availableBandColors; _i < _j.length; _i++) {
            var item = _j[_i];
            if (((_a = item.caseFinish) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === ((_b = this.currentSelelected.caseFinish) === null || _b === void 0 ? void 0 : _b.toUpperCase()) &&
                ((_c = item.caseColor) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === ((_d = this.currentSelelected.caseColor) === null || _d === void 0 ? void 0 : _d.toUpperCase()) &&
                ((_e = item.bandSize) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === ((_f = this.currentSelelected.bandSize) === null || _f === void 0 ? void 0 : _f.toUpperCase()) &&
                ((_g = item.bandType) === null || _g === void 0 ? void 0 : _g.toUpperCase()) === ((_h = this.currentSelelected.bandType) === null || _h === void 0 ? void 0 : _h.toUpperCase())) {
                availableBandColorsFiltered.push(item);
            }
        }
        return (React.createElement(ui_components_2.RadioGroup, { data: groupData, events: { onChange: this.onBandColorChange }, options: { elementsDirection: 'row' }, testId: 'WLS_Band_Color_Radio_Group' }, this.bandColorOptions && this.bandColorOptions.map(function (options, index) {
            var isBandColorAvailable = false;
            availableBandColorsFiltered.forEach(function (item) {
                if (options.bandColor === item.bandColor) {
                    isBandColorAvailable = true;
                }
            });
            var colorData = {
                color: options.bandHexValue,
                disabled: false,
                options: options.bandColor,
                strike: !isBandColorAvailable,
                value: options.bandColor,
            };
            return (React.createElement(ui_components_2.RadioColor, { key: "color_" + options.bandColor, data: colorData, options: {
                    accessibility: options.bandColor,
                    arialabelledby: 'radioColor_' + index,
                    className: styles.colorsize,
                    tabIndex: 0
                } }));
        })));
    };
    EditCapacity.prototype.displayColorOption = function () {
        var _this = this;
        var groupData = {
            defaultChecked: this.currentSelelected.deviceColor,
            name: 'wlsDeviceColorGroup',
            selected: this.currentSelelected.deviceColor,
        };
        return (React.createElement(ui_components_2.RadioGroup, { data: groupData, events: { onChange: this.onColorChange }, options: { elementsDirection: 'row' }, testId: 'WLS_Device_Color_Radio_Group' }, this.colorOptions && this.colorOptions.map(function (options, index) {
            var isColorAvailable = false;
            _this.availableColors.forEach(function (item) {
                if (options.color === item.color) {
                    isColorAvailable = true;
                }
            });
            var colorData = {
                color: options.htmlColor,
                disabled: false,
                options: options.color,
                strike: !isColorAvailable,
                value: options.color,
            };
            return (React.createElement(ui_components_2.RadioColor, { key: "color_" + options.color, data: colorData, options: {
                    accessibility: options.color,
                    arialabelledby: 'radioColor_' + index,
                    className: styles.colorsize,
                    tabIndex: 0
                } }));
        })));
    };
    EditCapacity.prototype.submitSaveDevice = function () {
        var _this = this;
        var cartResponse = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('APPSHELL'), 'cartResponse');
        var redirectionURL = Utils.isLoginRequiredonCart() && Utils.getauthenticatedPersistantLoginURL();
        this.setState({ isInsuranceModified: false });
        if (redirectionURL && typeof window !== undefined) {
            window.location.href = redirectionURL;
        }
        else {
            var addToCartData = this.buildAddToCartData();
            this.reportingService.fireCartUpdateSubmitEvent(false, '-2', ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, this.saveLabel, JSON.stringify(cartResponse), CartUtilFunctions_1.getLinkClickBasekUrl());
            this.props.events.doLoading(true);
            this.api.addToCart(addToCartData).then(function (data) {
                _this.props.events.doLoading(false);
                if (data && data.content && data.content.payload &&
                    (data.content.payload.wirelessCart || data.content.payload.commonCart)) {
                    _this.reportingService.fireCartUpdateSubmitEvent(false, '0', ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, _this.saveLabel, JSON.stringify(data), CartUtilFunctions_1.getLinkClickBasekUrl());
                    _this.stateManager.set('cartUpdate', { cartRefresh: true });
                    _this.stateManager.set('deviceUpdate', { deviceConfigRefresh: true });
                    if (_this.props.events && _this.props.events.onDeviceChange) {
                        _this.props.events.onDeviceChange(true);
                    }
                }
                else {
                    _this.reportingService.fireCartUpdateSubmitEvent(true, undefined, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, _this.saveLabel, JSON.stringify(data), CartUtilFunctions_1.getLinkClickBasekUrl());
                }
                _this.setState({ showCapacityModal: false });
                _this.props.events.doLoading(false);
            }).catch(function (error) {
                _this.props.events.doLoading(false);
                _this.reportingService.fireCartUpdateSubmitEvent(false, error && error.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, _this.saveLabel, JSON.stringify(error), CartUtilFunctions_1.getLinkClickBasekUrl());
            });
        }
    };
    EditCapacity.prototype.buildAddToCartData = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var payload = Utils.getCartResp();
        this.isCommonCart = Utils.isCommonCartPresent();
        var selectedProduct;
        var isAppleWearable = wlsUtils.isAppleWearableLineItem((_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.lineItemData);
        var isCaribbeanUser = wlsUtils.isCaribbeanFlow();
        this.filteredData['cpty-' + this.currentSelelected.deviceInternalMemory].forEach(function (product) {
            if (payload.enableEditIwatchBandInfo === true && isAppleWearable) {
                if (product.caseFinish === _this.currentSelelected.caseFinish &&
                    product.caseColor === _this.currentSelelected.caseColor &&
                    product.bandType === _this.currentSelelected.bandType &&
                    product.bandSize === _this.currentSelelected.bandSize &&
                    product.bandColor === _this.currentSelelected.bandColor) {
                    selectedProduct = product;
                }
            }
            else {
                if (product.color === _this.currentSelelected.deviceColor) {
                    selectedProduct = product;
                }
            }
        });
        var addToCartRequest = {
            itemsList: [this.buildAddToCartList(selectedProduct, payload)],
            serviceContext: {
                srcSystem: 'IDSE',
            },
            shoppingContext: wlsUtils.buildShoppingContext(payload, this.productDetails.losgType),
        };
        if (isCaribbeanUser) {
            addToCartRequest.shoppingContext.fnCaribbean = true;
        }
        if (CartUtilFunctions_1.getHylaPromotionId() || CartUtilFunctions_1.getHylaPromotionBillingCode()) {
            if (this.productDetails.losgType === 'UP' || Utils.getCurrentFlowType() === 'UP_AL_WIRELESS') {
                addToCartRequest.shoppingContext.offerCode = CartUtilFunctions_1.getHylaPromotionBillingCode();
            }
            else {
                addToCartRequest.shoppingContext.offerCode = CartUtilFunctions_1.getHylaPromotionId();
            }
        }
        if (CartUtilFunctions_1.getTradeInPortInConsented().hylatradeInCustomerConsented !== undefined &&
            CartUtilFunctions_1.getTradeInPortInConsented().hylatradeInCustomerConsented) {
            addToCartRequest.hylaTradeInIntentIndicator =
                CartUtilFunctions_1.getTradeInPortInConsented().hylatradeInCustomerConsented;
        }
        if (CartUtilFunctions_1.getTradeInPortInConsented().portInCustomerConsented !== undefined &&
            CartUtilFunctions_1.getTradeInPortInConsented().portInCustomerConsented) {
            addToCartRequest.portInIntentIndicator =
                CartUtilFunctions_1.getTradeInPortInConsented().portInCustomerConsented;
        }
        if (this.props.data.tradeinLineItem) {
            addToCartRequest.shoppingContext.hylaTradeInInfo = {
                capacity: (_d = (_c = this.props.data.tradeinLineItem.wirelessLineItemCharacteristics) === null || _c === void 0 ? void 0 : _c.tradeInDetail) === null || _d === void 0 ? void 0 : _d._capacity,
                modelPrice: (_e = this.props.data.tradeinLineItem.price) === null || _e === void 0 ? void 0 : _e.amount,
                modelcode: (_g = (_f = this.props.data.tradeinLineItem.wirelessLineItemCharacteristics) === null || _f === void 0 ? void 0 : _f.tradeInDetail) === null || _g === void 0 ? void 0 : _g.modelcode,
                questions: (_j = (_h = this.props.data.tradeinLineItem.wirelessLineItemCharacteristics) === null || _h === void 0 ? void 0 : _h.tradeInDetail) === null || _j === void 0 ? void 0 : _j.questions,
                tradeInDeviceCondition: (_l = (_k = this.props.data.tradeinLineItem.wirelessLineItemCharacteristics) === null || _k === void 0 ? void 0 : _k.tradeInDetail) === null || _l === void 0 ? void 0 : _l._tradeInDeviceCondition,
            };
            addToCartRequest.shoppingContext.hylaImageUrl = (_m = this.props.data.tradeinLineItem.hardGood) === null || _m === void 0 ? void 0 : _m.productImageUrl;
            addToCartRequest.shoppingContext.make = (_o = this.props.data.tradeinLineItem.hardGood) === null || _o === void 0 ? void 0 : _o.make;
            addToCartRequest.shoppingContext.model = (_p = this.props.data.tradeinLineItem.hardGood) === null || _p === void 0 ? void 0 : _p.model;
            addToCartRequest.shoppingContext.hylaDiscountAmount = this.props.data.estimatedTradeInValue ?
                Number(this.props.data.estimatedTradeInValue) : 0;
            addToCartRequest.shoppingContext.sku = this.props.data.tradeinLineItem.productSKU;
        }
        return addToCartRequest;
    };
    EditCapacity.prototype.mapInstallenmentPlanDefinition = function (installmentPlanDefinition, contractDisplayName, contractType) {
        if (contractDisplayName && contractDisplayName.toUpperCase() === '2 YEAR') {
            return '2Year';
        }
        else if ((installmentPlanDefinition && installmentPlanDefinition.toUpperCase() === 'REGULAR') ||
            (contractType && contractType.toUpperCase() === 'NOCOMMIT' && this.isCommonCart)) {
            return 'NoCommitment';
        }
        return installmentPlanDefinition;
    };
    EditCapacity.prototype.getProductContractDetails = function (product) {
        var _this = this;
        var productContractDetails = {
            commitmentTermId: '',
            contractLength: 0,
            contractType: '',
        };
        if (product && product.price) {
            var priceDetails = product.price.
                find(function (price) { return price.commitmentTerm ===
                _this.mapInstallenmentPlanDefinition(_this.productDetails.installmentPlanDefinition, _this.productDetails.contractDisplayName, _this.productDetails.contractType); });
            if (priceDetails) {
                productContractDetails.contractLength = priceDetails.termLength;
                productContractDetails.contractType = priceDetails.type;
                productContractDetails.commitmentTermId = priceDetails.commitmentTermId;
            }
        }
        return productContractDetails;
    };
    EditCapacity.prototype.getExtDeliveryDates = function () {
        var _this = this;
        // When the Edit Capacity Modal is first opened, then this.deliveryDate is null
        // so, set this.deliveryDate initially with the cartSummary's estimatedDeliveryDate
        this.deliveryDate = this.deliveryDate || this.props.data.estimatedDeliveryDates;
        if (this.billCodes.length > 0 && (this.billCodeRespObj === undefined || this.billCodeRespObj === null) &&
            this.state.showCapacityModal) {
            if (this.props.data && this.props.data.showDeliveryDates) {
                this.api.getDeliveryDates(this.billCodes).then(function (response) {
                    _this.billCodeRespObj = response;
                    _this.setDeliveryDates();
                    if (_this.props.events && _this.props.events.updateBillCodes) {
                        _this.props.events.updateBillCodes(response);
                    }
                }).catch(function (error) {
                    _this.setState({ showEstDeliveryDate: false });
                });
            }
            else {
                this.setState({ showEstDeliveryDate: false });
            }
        }
        else if (this.billCodes.length > 0 && this.billCodeRespObj !== undefined && this.billCodeRespObj !== null &&
            this.state.showCapacityModal) {
            this.setDeliveryDates();
        }
    };
    EditCapacity.prototype.setDeliveryDates = function () {
        if (this.props.data && this.props.data.showDeliveryDates) {
            var dateFound = false;
            if (this.currentSelelected.deviceInternalMemory && this.currentSelelected.deviceInternalMemory > 0) {
                var capacity = CAPACITY_NAME + this.currentSelelected.deviceInternalMemory;
                if (this.filteredData && this.filteredData[capacity]) {
                    var availableColorsforMemory = this.filteredData[capacity];
                    for (var _i = 0, availableColorsforMemory_1 = availableColorsforMemory; _i < availableColorsforMemory_1.length; _i++) {
                        var item = availableColorsforMemory_1[_i];
                        if (this.currentSelelected.productSKU === item.productSKU && item.billingInfo &&
                            item.billingInfo.billCode && this.billCodeRespObj[item.billingInfo.billCode]) {
                            var dateObj = this.billCodeRespObj[item.billingInfo.billCode];
                            this.deliveryDate = dateObj && dateObj.deliveryDates &&
                                dateObj.deliveryDates.dateFrom && dateObj.deliveryDates.dateTo &&
                                " " + dateObj.deliveryDates.dateFrom.split(',')[0] + " -\n                                " + dateObj.deliveryDates.dateTo.split(',')[0];
                            dateFound = true;
                            break;
                        }
                    }
                }
                this.setState({ showEstDeliveryDate: dateFound });
            }
        }
    };
    EditCapacity.prototype.setDefaultFocus = function () {
        var _this = this;
        setTimeout(function () {
            var focusElement = document.getElementById('Cart_Capacity_Change_Modal_modaldialogdesc_hdrText');
            if (focusElement && focusElement.hasOwnProperty('focus')) {
                focusElement.focus();
            }
            _this.setDefaultFocusDone = true;
        }, 500);
    };
    EditCapacity.prototype.buildAddToCartList = function (selectedProduct, payload) {
        if (this.isCommonCart) {
            var alParam = wlsUtils.buildLineItemExtraParam(payload, this.productDetails.losgId);
            var listdata = {
                accountId: alParam.accountId,
                action: CartActions_1.ActionType.MODIFY,
                contractDetails: {
                    commitmentTerm: this.mapInstallenmentPlanDefinition(this.productDetails.installmentPlanDefinition, this.productDetails.contractDisplayName, this.productDetails.contractType),
                    commitmentTermId: this.getProductContractDetails(selectedProduct).commitmentTermId,
                    contractLength: this.getProductContractDetails(selectedProduct).contractLength,
                    contractType: this.getProductContractDetails(selectedProduct).contractType,
                },
                itemId: this.productDetails.itemId,
                itemType: CartActions_1.ItemType.DEVICE,
                losgId: this.productDetails.losgId,
                losgType: this.productDetails.losgType,
                primaryPlanSubscriber: alParam.primaryPlanSubscriber,
                productGroup: CartActions_1.ProductGroupType.WIRELESS,
                productRootId: alParam.productRootId,
                productSKU: selectedProduct.productSKU,
                quantity: 1,
            };
            return listdata;
        }
        else {
            var listdata = {
                action: CartActions_1.ActionType.MODIFY,
                commitmentTerm: this.mapInstallenmentPlanDefinition(this.productDetails.installmentPlanDefinition, this.productDetails.contractDisplayName),
                commitmentTermId: this.getProductContractDetails(selectedProduct).commitmentTermId,
                continueCurrentCart: !!selectedProduct.continueCurrentCart,
                contractLength: this.getProductContractDetails(selectedProduct).contractLength,
                contractType: this.getProductContractDetails(selectedProduct).contractType,
                fulfillerId: selectedProduct.fulfillerId,
                fulfillerName: selectedProduct.fulfillerName,
                isThirdParty: selectedProduct.isThirdParty,
                itemId: this.productDetails.itemId,
                itemType: CartActions_1.ItemType.DEVICE,
                losgId: this.productDetails.losgId,
                losgType: this.productDetails.losgType,
                offerId: selectedProduct.offerId,
                productGroup: CartActions_1.ProductGroupType.WIRELESS,
                productId: 'NA',
                productSKU: selectedProduct.productSKU,
                quantity: 1,
            };
            return listdata;
        }
    };
    return EditCapacity;
}(React.Component));
exports.default = EditCapacity;
//# sourceMappingURL=EditCapacity.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/EditCapacity/EditCapacity.js
// module id = 2286
// module chunks = 8